module.exports = __webpack_public_path__ + "img/com.electrolux.visionmobile.d15b6518.webp";